import { ProgressBarDesignTokens } from '@primeuix/themes/types/progressbar';

export const progressBarPreset: ProgressBarDesignTokens = {
  // The track (root background) is the unfilled remainder of the bar, so it's the one coloured
  // with the "selected" blue here — the filled value represents the amount already assigned.
  root: {
    background: 'var(--content-selected)',
  },
  value: {
    background: 'var(--content-neutral-tertiary)',
  },
};
